<template>
  <div 
    v-loading="loading"
    element-loading-background="rgba(0,0,0,0.3)"
  >
    
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      arrowList: [
        {
          name: "设备中心",
          path: "/transfer/equipmentCenter",
        },
        {
          name: "位置监控",
          path: "/transfer/equipmentMonitor",
        },
      ],
      loading:true
    };
  },
  computed: {
    
  },
  created() {},
  mounted() {
      this.$router.push({name:'EquipmentMonitor',params:{}})
  },
  methods: {
    
  },
  watch:{
    
  },
  components: {},
};
</script>
